import React from 'react';
import { AlertTriangle } from 'lucide-react';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';

interface SessionTimeoutModalProps {
  isOpen: boolean;
  secondsRemaining: number;
  onContinue: () => void;
  onLogout: () => void;
  isRefreshing?: boolean;
}

const SessionTimeoutModal: React.FC<SessionTimeoutModalProps> = ({
  isOpen,
  secondsRemaining,
  onContinue,
  onLogout,
  isRefreshing = false,
}) => {
    return (
    <Modal
      isOpen={isOpen}
      onClose={onLogout}
      title="Sesion por inactividad"
      maxWidth="max-w-lg"
      footer={(
        <div className="flex items-center justify-end gap-3">
          <Button variant="outline" onClick={onLogout}>
            Cerrar sesion
          </Button>
          <Button onClick={onContinue} isLoading={isRefreshing}>
            Continuar sesion
          </Button>
        </div>
      )}
    >
      <div className="flex items-start gap-3">
        <div className="mt-0.5 text-amber-600">
          <AlertTriangle size={20} />
        </div>
        <div className="space-y-2">
          <p className="text-slate-700">
            Por seguridad, tu sesion se cerrara en <strong>{secondsRemaining}</strong> segundos por inactividad.
          </p>
          <p className="text-sm text-slate-500">
            Selecciona "Continuar sesion" para mantenerte autenticado o "Cerrar sesion" para salir ahora.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default SessionTimeoutModal;
